import React from 'react'
import { observer } from 'mobx-react-lite'
import statsStore from '../../store/stats'
import { PositionRowCell } from './PositionRowCell'
import { date } from '../../utils/date'

export const PositionRow = observer((
  {
    data
  }
) => {

  const { initialGridTemplate } = statsStore

  const {
    title,
    code,
    drawings,
    id,
    quantity,
    readyDate,
    order: {
      orderId,
      company,
      date: orderDate,
      manager,
    }
  } = data

  const isWithDrawings = !!drawings.length
  const positionReadyDate = date.transform(readyDate, false)
  const orderDateFormated = date.transform(orderDate, false)

  return (
    <div className={`grid odd:bg-[#FFFFFF] even:bg-[#FAFAFA] mt-[1px] min-h-[62px]`} style={{ gridTemplateColumns: initialGridTemplate.map(w => `${w}rem`).join(' ') }}>
      <PositionRowCell textContent={title} copy/>
      <PositionRowCell textContent={code} copy/>
      <PositionRowCell>{quantity}</PositionRowCell>
      {/*Логотип*/}
      <PositionRowCell>
        {isWithDrawings
          ? <div className={`flex flex-col gap-[2px]`}>
            {drawings.map(dr => <span className={`text-Regular(12_14)`}>{dr.logo || '-'}</span>)}
          </div>
          : '-'
        }
      </PositionRowCell>
      {/*Метод печати*/}
      <PositionRowCell>
        {isWithDrawings
          ? <div className={`flex flex-col gap-[2px]`}>
            {drawings.map(dr => <span className={`text-Regular(12_14)`}>{dr.name || '-'}</span>)}
          </div>
          : '-'
        }
      </PositionRowCell>
      {/*Кол-во цветов*/}
      <PositionRowCell>
        {isWithDrawings
          ? <div className={`flex flex-col gap-[2px]`}>
            {drawings.map(dr => <span className={`text-Regular(12_14)`}>{dr.stamps || '1'}</span>)}
          </div>
          : '-'
        }
      </PositionRowCell>
      <PositionRowCell textContent={manager}></PositionRowCell>
      <PositionRowCell textContent={orderId} copy/>
      <PositionRowCell textContent={company} copy/>
      <PositionRowCell>{orderDateFormated}</PositionRowCell>
      <PositionRowCell>{positionReadyDate}</PositionRowCell>
    </div>
  )
})